const actionTypes = {
  REPLACE_CONTENT: 'REPLACE_CONTENT', // 替换内容
  REMOVE_CONTENT: 'REMOVE_CONTENT', // 移除内容
  SWITCH_LAYOUT_PRESET: 'SWITCH_LAYOUT_PRESET', // 更改布局
  ADD_SECTION: 'ADD_SECTION', // 添加版块
  REMOVE_SECTION: 'REMOVE_SECTION', // 移除版块
  ADD_SECTION_ELEMENT: 'ADD_SECTION_ELEMENT', // 添加版块元素
  REMOVE_SECTION_ELEMENT: 'REMOVE_SECTION_ELEMENT', // 移除版块元素
  ADD_SECTION_LIST_ITEM: 'ADD_SECTION_LIST_ITEM', // 添加版块列表项
  REMOVE_SECTION_LIST_ITEM: 'REMOVE_SECTION_LIST_ITEM' // 移除版块列表项
}

export default actionTypes


// WEBPACK FOOTER //
// ./app/javascript/app/site/actions/types.js